import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'
import Seo from '../components/seo'
import styles from './documenti.module.css'
import Layout from '../components/layout'
import { Grid, Typography } from '@material-ui/core'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import { PRIVACY_NOTICE_URL } from '../components/form-signin/privacy-settings'

let PDFViewer = () => <div />;

const Documenti = (props) => {
  const altriDocumenti = get(props, 'data.allContentfulDocumento.edges', [])
    .map((documento) => documento.node.documento)
    .filter(Boolean)
    .filter((documento) => !/privacy/i.test([
      documento.title,
      documento.description,
      get(documento, 'file.url', ''),
    ].join(' ')))
  const documenti = [
    {
      id: 'informativa-privacy-mrf',
      title: 'Informativa privacy',
      file: { url: PRIVACY_NOTICE_URL },
    },
    ...altriDocumenti,
  ]
  const pageTitle = 'Movimento Rivoluzione Fiscale - Documenti'

  const [hasMounted, setHasMounted] = React.useState(false);

  React.useEffect(() => {
    PDFViewer = require('pdf-viewer-reactjs');
    setHasMounted(true);
  }, []);

  return (
    <Layout location={props.location}>
      <Seo title="Documenti e statuto MRF" description="Statuto, documenti ufficiali e informativa privacy del Movimento Rivoluzione Fiscale." path="/documenti/" />
      <div className={styles.container}>
        <div className={styles.gridContainer}>
          <Grid container spacing={2} className={styles.documentsContainer}>
            <Grid item xs={12} className={styles.titleContainer}>
              <Typography variant={'h3'} component="h1">{pageTitle}</Typography>
            </Grid>
            {documenti.map((documento) => (
              <Grid item xs={12} key={documento.id || documento.title}>
                <a
                  className={styles.documentContainer}
                  href={documento.file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <PictureAsPdfIcon className={styles.icon} />
                  <Typography variant={'body1'}>{documento.title}</Typography>
                </a>
              </Grid>
            ))}
            <Grid item xs={12} className={styles.titleContainer}>
              <Typography variant={'h3'} style={{marginTop: 30}}>Statuto</Typography>
            </Grid>
            <Grid item xs={12}>
              {
                hasMounted && (<PDFViewer
                  hideZoom
                  hideRotation
                  rotationAngle={-90}
                  canvasCss={styles.pdfContainer}
                  document={{
                    url: 'https://downloads.ctfassets.net/mliqjt4giyw6/1Sn2vSuJSR8nZreL3Eanmh/6083cc767ee3cf8d2a222e117fd9f42a/ATTO_COSTITUTIVO_-MRF-NOTAIO_BERTONCINO.pdf',
                  }}
                />)
              }
            </Grid>
          </Grid>
        </div>
      </div>
    </Layout>
  )
}

export default Documenti

export const pageQuery = graphql`
  query BlogDocumenti {
    allContentfulDocumento {
      edges {
        node {
          documento {
            id
            description
            title
            file {
              url
            }
          }
        }
      }
    }
  }
`
